// @flow
import * as React from "react"
import { Link } from "react-static"
import { hot } from "react-hot-loader"
import { ImageFit } from "../../components/ImageFit"
import { setHtml } from "../../utils"
import { tRouteProps, tCommunityGroupsTemplate, tService } from "../../types"
import { Container } from "../../components/StyledComponents"
import { css } from "emotion/macro"
import { color, mq } from "../../styles/variables"
import { FlexibleContent } from "../../components/FlexibleContent"
import { PageMeta } from "../../components/PageMeta"

type tCommunityGroups = tCommunityGroupsTemplate

function CommunityGroups(props: tCommunityGroups & tRouteProps) {
  const {
    services,
    weekdays_marquee_image: marquee
  } = props.services_template_content
  return (
    <div
      className={css`
        h2 {
          margin-bottom: 30px;
        }

        * {
          box-sizing: border-box;
        }

        .services {
          .service {
            margin-bottom: 60px;
          }

          .service-title-link {
            color: ${color.rgb.purple[1]};
          }

          .service-header {
            border-bottom-width: 4px;
            border-bottom-style: solid;
            font-weight: 600;
            color: #000;
            padding-bottom: 7.5px;
            margin-bottom: 15px;

            p {
              margin: 0;
            }
          }

          .title {
            line-height: 25px;
            font-size: 20px;
          }

          .time {
            line-height: 25px;
            font-size: 16px;
          }

          .service-sun {
            &:nth-of-type(even) .service-header {
              border-bottom-color: ${color.rgb.purple[1]};
            }
            &:nth-of-type(odd) .service-header {
              border-bottom-color: ${color.rgb.orange[0]};
            }
          }

          .service-mon .service-header {
            border-bottom-color: ${color.rgb.green[0]};
          }
          .service-tue .service-header {
            border-bottom-color: ${color.rgb.navy[0]};
          }
          .service-wed .service-header {
            border-bottom-color: ${color.rgb.yellow[0]};
          }
          .service-thu .service-header {
            border-bottom-color: ${color.rgb.teal[1]};
          }
          .service-fri .service-header {
            border-bottom-color: ${color.rgb.red[0]};
          }
          .service-sat .service-header {
            border-bottom-color: ${color.rgb.violet[0]};
          }

          ${mq.md(css`
            display: flex;
            flex-wrap: wrap;

            > div {
              width: calc(50% - 15px);
              page-break-inside: avoid;

              &:nth-of-type(odd) {
                margin-right: 30px;
              }
            }
          `)};
        }
      `}
    >
      <PageMeta
        title={props.title}
        description="A Place to Belong, Sundays and Weekday services."
        image={props.brand.logo}
      />
      <Container>
        {props.flexible_content && (
          <FlexibleContent items={props.flexible_content} />
        )}
      </Container>
      <section
        className={css`
          border-top: 1px solid ${color.rgb.gray[2]};
          padding-top: 60px;
          padding-bottom: 60px;
        `}
      >
        <Container>
          <h2 className="text-center">Sundays</h2>
          <div className="services">
            {services
              .filter((service) => service.day === "sun")
              .map((service, i) => (
                <Service
                  {...{
                    ...service,
                    day: "sun"
                  }}
                  key={i}
                />
              ))}
          </div>
        </Container>
      </section>
      <section
        className={css`
          border-top: 1px solid ${color.rgb.gray[2]};
          padding-top: 60px;
          padding-bottom: 60px;
        `}
      >
        <Container>
          {marquee && (
            <ImageFit
              src={marquee.url}
              alt={marquee.alt}
              style={{ width: "100%", height: "340px", marginBottom: "60px" }}
            />
          )}
          <Weekdays services={services} />
        </Container>
      </section>
    </div>
  )
}

const weekedays = [
  {
    abr: "mon",
    full: "Monday"
  },
  {
    abr: "tue",
    full: "Tuesday"
  },
  {
    abr: "wed",
    full: "Wednesday"
  },
  {
    abr: "thu",
    full: "Thursday"
  },
  {
    abr: "fri",
    full: "Friday"
  },
  {
    abr: "sat",
    full: "Saturday"
  }
]

const Weekdays = ({ services }: { services: Array<tService> }) => (
  <div className="services">
    {weekedays.map((weekday) => (
      <React.Fragment key={weekday.abr}>
        {services
          .filter((service) => service.day === weekday.abr)
          .map((service, i) => {
            if (i === 0) {
              return (
                <div key={`week-wrapper-${weekday.abr}`}>
                  <h2 className="text-center" {...setHtml(weekday.full)} />

                  <Service
                    {...{
                      ...service,
                      day: weekday.abr
                    }}
                    key={i}
                  />
                </div>
              )
            }
            return (
              <Service
                {...{
                  ...service,
                  day: weekday.abr
                }}
                key={i}
              />
            )
          })}
      </React.Fragment>
    ))}
  </div>
)

const Service = (props: { ...tService, day: string }) => (
  <div className={`service service-${props.day}`}>
    <div className="service-header">
      {props.url ? (
        <Link to={props.url} className={"service-title-link"}>
          <p className="title" {...setHtml(props.title)} />
        </Link>
      ) : (
        <p className="title" {...setHtml(props.title)} />
      )}
      <p className="time" {...setHtml(props.time)} />
    </div>
    <div className="service-content" {...setHtml(props.content)} />
  </div>
)

export default hot(module)(CommunityGroups)



// WEBPACK FOOTER //
// /opt/build/repo/src/screens/Page/CommunityGroups.js